export default __webpack_public_path__ + "static/media/Group 491.f4e8a8d8.png";